export { default as TemplatesView } from './templates';
